import { render, staticRenderFns } from "./images.vue?vue&type=template&id=9f064358&scoped=true"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"
import style0 from "./images.vue?vue&type=style&index=0&id=9f064358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f064358",
  null
  
)

export default component.exports